import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faLink, faSync } from '@fortawesome/free-solid-svg-icons';
import Layout from '../components/Layout';
import trackingLinkService from '../services/trackingLinkService';
import { useTranslation } from 'react-i18next';
import './TrackingLinks.css';

const TrackingLinks = () => {
  const { t } = useTranslation();

  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');
      const linksData = await trackingLinkService.getAll();
      setLinks(linksData);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(id);
      setTimeout(() => setCopied(''), 2000);
    });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value || 0);
  };

  return (
    <Layout>
      <div className="tracking-links-page">
        {loading ? (
          <div className="loading-container">{t('common.loading', 'Carregando...')}</div>
        ) : (
          <>
            <div className="tracking-links-header">
              <h1 className="tracking-links-title">{t('sidebar.tracking_links', 'Links de Rastreamento')}</h1>
              <div className="header-actions">
                <button onClick={loadData} className="btn btn-primary radius-8 px-14 py-6 text-sm">
                  <FontAwesomeIcon icon={faSync} /> {t('common.refresh', 'Atualizar')}
                </button>
              </div>
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            {links.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">
                  <FontAwesomeIcon icon={faLink} />
                </div>
                <p>{t('tracking_links.no_links', 'Nenhum link de rastreamento encontrado.')}</p>
                <p>{t('tracking_links.no_links_hint', 'Os links de rastreamento sao criados na aba do bot correspondente.')}</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table className="tracking-links-table">
                  <thead>
                    <tr>
                      <th>{t('tracking_links.label', 'Titulo')}</th>
                      <th>{t('tracking_links.bot_user', 'Usuario bot')}</th>
                      <th>{t('tracking_links.sales_qty', 'Vendas (quat.)')}</th>
                      <th>{t('tracking_links.sales_value', 'Vendas (valor)')}</th>
                      <th>{t('tracking_links.leads', 'Leads')}</th>
                      <th>{t('tracking_links.identifier', 'Identificador')}</th>
                      <th>{t('tracking_links.generated_link', 'Link gerado')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {links.map((link) => (
                      <tr key={link.id}>
                        <td className="label-cell">{link.label || '-'}</td>
                        <td className="bot-username-cell">{link.bot_username || '-'}</td>
                        <td className="number-cell">{link.sales_count || 0} Vendas</td>
                        <td className="number-cell">{formatCurrency(link.sales_value)}</td>
                        <td className="number-cell">{link.leads || 0} Leads</td>
                        <td>
                          <code className="code-badge">{link.code}</code>
                        </td>
                        <td>
                          <span
                            className={`deep-link-cell ${copied === link.id ? 'copied' : ''}`}
                            title={link.deep_link}
                            onClick={() => copyToClipboard(link.deep_link, link.id)}
                          >
                            {copied === link.id ? 'Copiado!' : link.deep_link}
                            <FontAwesomeIcon icon={faCopy} className="copy-icon" />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default TrackingLinks;
